export default __webpack_public_path__ + "static/media/pooltogether-logo.7c89aab9.svg";